export type VisualWebsiteOptimizer = {
  vwo_uuid: string;
};

export type WithVisualWebsiteOptimizer = Partial<VisualWebsiteOptimizer>;

export const VISUAL_WEBSITE_OPTIMIZER_KEY = 'vwo_uuid';
